const initialState={
	pais:{
		nombre:localStorage.getItem('paisNombre')?localStorage.getItem('paisNombre'):"",
		moneda:localStorage.getItem('moneda')?localStorage.getItem('moneda'):"",
		modenaIcono:localStorage.getItem('monedaIcono')?localStorage.getItem('monedaIcono'):"",
		ISO:localStorage.getItem('ISO')?localStorage.getItem('ISO'):"",
		bandera:localStorage.getItem('bandera')?localStorage.getItem('bandera'):""},
	tipoCambio:null	
};

export default function paisReducer(state= initialState,action){
	switch(action.type){
		case 'PAIS':
     		return {...state,pais:action.payload};

     	case 'TIPOCAMBIO':
     		return {...state,tipoCambio:action.payload};

     	default:
     		return state
	}
}